// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3QsWX","signatureButtonsRight":"ModalSign_signatureButtonsRight__QlQ85"};